export const stockButtonBase =
  'inline-flex items-center justify-center gap-2 rounded-2xl border px-4 py-2.5 text-sm font-semibold transition-all duration-200 ease-out focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white disabled:cursor-not-allowed disabled:opacity-60';

export const stockButtonTones = {
  primary:
    `${stockButtonBase} border-slate-950 bg-[linear-gradient(135deg,#0f172a_0%,#111827_45%,#0891b2_100%)] text-white shadow-[0_16px_30px_rgba(8,145,178,0.18)] hover:-translate-y-0.5 hover:shadow-[0_18px_36px_rgba(8,145,178,0.22)] focus:ring-cyan-400`,
  cyan:
    `${stockButtonBase} border-cyan-500 bg-[linear-gradient(135deg,#0891b2_0%,#06b6d4_100%)] text-white shadow-[0_14px_30px_rgba(6,182,212,0.2)] hover:-translate-y-0.5 hover:shadow-[0_18px_32px_rgba(6,182,212,0.24)] focus:ring-cyan-300`,
  violet:
    `${stockButtonBase} border-violet-500 bg-[linear-gradient(135deg,#7c3aed_0%,#8b5cf6_100%)] text-white shadow-[0_14px_30px_rgba(139,92,246,0.18)] hover:-translate-y-0.5 hover:shadow-[0_18px_34px_rgba(139,92,246,0.24)] focus:ring-violet-300`,
  emerald:
    `${stockButtonBase} border-emerald-500 bg-[linear-gradient(135deg,#059669_0%,#10b981_100%)] text-white shadow-[0_14px_30px_rgba(16,185,129,0.18)] hover:-translate-y-0.5 hover:shadow-[0_18px_34px_rgba(16,185,129,0.22)] focus:ring-emerald-300`,
  ghost:
    `${stockButtonBase} border-slate-200 bg-white/92 text-slate-700 shadow-[0_10px_22px_rgba(15,23,42,0.06)] hover:-translate-y-0.5 hover:border-slate-300 hover:bg-white hover:text-slate-950 hover:shadow-[0_14px_26px_rgba(15,23,42,0.1)] focus:ring-slate-300`,
  softViolet:
    `${stockButtonBase} border-violet-200 bg-violet-50/90 text-violet-700 shadow-[0_10px_24px_rgba(139,92,246,0.1)] hover:-translate-y-0.5 hover:border-violet-300 hover:bg-violet-100 focus:ring-violet-300`,
  softEmerald:
    `${stockButtonBase} border-emerald-200 bg-emerald-50/90 text-emerald-700 shadow-[0_10px_24px_rgba(16,185,129,0.1)] hover:-translate-y-0.5 hover:border-emerald-300 hover:bg-emerald-100 focus:ring-emerald-300`,
};

const stockNavTones = {
  planner: {
    active: 'border-sky-200 bg-[linear-gradient(135deg,#eff6ff_0%,#e0f2fe_48%,#ecfeff_100%)] shadow-[0_18px_35px_rgba(14,165,233,0.14)] ring-1 ring-sky-200/80',
    idle: 'hover:border-sky-200 hover:bg-sky-50/80 hover:shadow-[0_14px_28px_rgba(14,165,233,0.1)]',
    iconActive: 'border-white/70 bg-[linear-gradient(135deg,#ffffff_0%,#dbeafe_58%,#e0f2fe_100%)] shadow-[0_14px_30px_rgba(14,165,233,0.15)]',
    iconIdle: 'group-hover:border-sky-200 group-hover:bg-sky-50',
  },
  products: {
    active: 'border-emerald-200 bg-[linear-gradient(135deg,#f0fdf4_0%,#dcfce7_48%,#ecfdf5_100%)] shadow-[0_18px_35px_rgba(16,185,129,0.14)] ring-1 ring-emerald-200/80',
    idle: 'hover:border-emerald-200 hover:bg-emerald-50/80 hover:shadow-[0_14px_28px_rgba(16,185,129,0.1)]',
    iconActive: 'border-white/70 bg-[linear-gradient(135deg,#ffffff_0%,#dcfce7_58%,#ecfdf5_100%)] shadow-[0_14px_30px_rgba(16,185,129,0.15)]',
    iconIdle: 'group-hover:border-emerald-200 group-hover:bg-emerald-50',
  },
  purchases: {
    active: 'border-amber-200 bg-[linear-gradient(135deg,#fffbeb_0%,#fef3c7_48%,#ecfeff_100%)] shadow-[0_18px_35px_rgba(245,158,11,0.14)] ring-1 ring-amber-200/80',
    idle: 'hover:border-amber-200 hover:bg-amber-50/80 hover:shadow-[0_14px_28px_rgba(245,158,11,0.1)]',
    iconActive: 'border-white/70 bg-[linear-gradient(135deg,#ffffff_0%,#fef3c7_58%,#ecfeff_100%)] shadow-[0_14px_30px_rgba(245,158,11,0.15)]',
    iconIdle: 'group-hover:border-amber-200 group-hover:bg-amber-50',
  },
  outbound: {
    active: 'border-fuchsia-200 bg-[linear-gradient(135deg,#fdf4ff_0%,#fae8ff_48%,#eef2ff_100%)] shadow-[0_18px_35px_rgba(217,70,239,0.14)] ring-1 ring-fuchsia-200/80',
    idle: 'hover:border-fuchsia-200 hover:bg-fuchsia-50/80 hover:shadow-[0_14px_28px_rgba(217,70,239,0.1)]',
    iconActive: 'border-white/70 bg-[linear-gradient(135deg,#ffffff_0%,#fae8ff_58%,#eef2ff_100%)] shadow-[0_14px_30px_rgba(217,70,239,0.15)]',
    iconIdle: 'group-hover:border-fuchsia-200 group-hover:bg-fuchsia-50',
  },
  movements: {
    active: 'border-cyan-200 bg-[linear-gradient(135deg,#ecfeff_0%,#cffafe_44%,#e0e7ff_100%)] shadow-[0_18px_35px_rgba(6,182,212,0.14)] ring-1 ring-cyan-200/80',
    idle: 'hover:border-cyan-200 hover:bg-cyan-50/80 hover:shadow-[0_14px_28px_rgba(6,182,212,0.1)]',
    iconActive: 'border-white/70 bg-[linear-gradient(135deg,#ffffff_0%,#cffafe_58%,#e0e7ff_100%)] shadow-[0_14px_30px_rgba(6,182,212,0.15)]',
    iconIdle: 'group-hover:border-cyan-200 group-hover:bg-cyan-50',
  },
  controllers: {
    active: 'border-teal-200 bg-[linear-gradient(135deg,#f0fdfa_0%,#ccfbf1_48%,#f8fafc_100%)] shadow-[0_18px_35px_rgba(20,184,166,0.14)] ring-1 ring-teal-200/80',
    idle: 'hover:border-teal-200 hover:bg-teal-50/80 hover:shadow-[0_14px_28px_rgba(20,184,166,0.1)]',
    iconActive: 'border-white/70 bg-[linear-gradient(135deg,#ffffff_0%,#ccfbf1_58%,#f8fafc_100%)] shadow-[0_14px_30px_rgba(20,184,166,0.15)]',
    iconIdle: 'group-hover:border-teal-200 group-hover:bg-teal-50',
  },
  sheets: {
    active: 'border-violet-200 bg-[linear-gradient(135deg,#f5f3ff_0%,#ede9fe_48%,#faf5ff_100%)] shadow-[0_18px_35px_rgba(139,92,246,0.14)] ring-1 ring-violet-200/80',
    idle: 'hover:border-violet-200 hover:bg-violet-50/80 hover:shadow-[0_14px_28px_rgba(139,92,246,0.1)]',
    iconActive: 'border-white/70 bg-[linear-gradient(135deg,#ffffff_0%,#ede9fe_58%,#faf5ff_100%)] shadow-[0_14px_30px_rgba(139,92,246,0.15)]',
    iconIdle: 'group-hover:border-violet-200 group-hover:bg-violet-50',
  },
  reports: {
    active: 'border-orange-200 bg-[linear-gradient(135deg,#fff7ed_0%,#ffedd5_48%,#fefce8_100%)] shadow-[0_18px_35px_rgba(249,115,22,0.14)] ring-1 ring-orange-200/80',
    idle: 'hover:border-orange-200 hover:bg-orange-50/80 hover:shadow-[0_14px_28px_rgba(249,115,22,0.1)]',
    iconActive: 'border-white/70 bg-[linear-gradient(135deg,#ffffff_0%,#ffedd5_58%,#fefce8_100%)] shadow-[0_14px_30px_rgba(249,115,22,0.15)]',
    iconIdle: 'group-hover:border-orange-200 group-hover:bg-orange-50',
  },
  stats: {
    active: 'border-lime-200 bg-[linear-gradient(135deg,#f7fee7_0%,#ecfccb_48%,#f0fdf4_100%)] shadow-[0_18px_35px_rgba(132,204,22,0.14)] ring-1 ring-lime-200/80',
    idle: 'hover:border-lime-200 hover:bg-lime-50/80 hover:shadow-[0_14px_28px_rgba(132,204,22,0.1)]',
    iconActive: 'border-white/70 bg-[linear-gradient(135deg,#ffffff_0%,#ecfccb_58%,#f0fdf4_100%)] shadow-[0_14px_30px_rgba(132,204,22,0.15)]',
    iconIdle: 'group-hover:border-lime-200 group-hover:bg-lime-50',
  },
  assistant: {
    active: 'border-indigo-200 bg-[linear-gradient(135deg,#eef2ff_0%,#e0e7ff_48%,#f8fafc_100%)] shadow-[0_18px_35px_rgba(99,102,241,0.14)] ring-1 ring-indigo-200/80',
    idle: 'hover:border-indigo-200 hover:bg-indigo-50/80 hover:shadow-[0_14px_28px_rgba(99,102,241,0.1)]',
    iconActive: 'border-white/70 bg-[linear-gradient(135deg,#ffffff_0%,#e0e7ff_58%,#f8fafc_100%)] shadow-[0_14px_30px_rgba(99,102,241,0.15)]',
    iconIdle: 'group-hover:border-indigo-200 group-hover:bg-indigo-50',
  },
  neutral: {
    active: 'border-slate-900/10 bg-[linear-gradient(135deg,rgba(255,255,255,0.98)_0%,rgba(240,249,255,0.98)_46%,rgba(236,254,255,0.98)_100%)] shadow-[0_18px_35px_rgba(8,145,178,0.12)] ring-1 ring-cyan-200/70',
    idle: 'hover:border-slate-200 hover:bg-white/90 hover:shadow-[0_14px_28px_rgba(15,23,42,0.06)]',
    iconActive: 'border-white/70 bg-[linear-gradient(135deg,#ffffff_0%,#f0f9ff_58%,#ecfeff_100%)] shadow-[0_14px_30px_rgba(8,145,178,0.14)]',
    iconIdle: 'group-hover:border-slate-300 group-hover:bg-white',
  },
};

export const getStockNavButtonClass = (active = false, tone = 'neutral') => {
  const palette = stockNavTones[tone] || stockNavTones.neutral;

  return [
    'group relative w-full overflow-hidden rounded-[24px] border px-3.5 py-3.5 transition-all duration-200',
    active ? palette.active : `border-transparent bg-white/0 ${palette.idle}`,
  ].join(' ');
};

export const getStockNavIconWrapClass = (active = false, accent = 'text-cyan-600', tone = 'neutral') => {
  const palette = stockNavTones[tone] || stockNavTones.neutral;

  return [
    'flex h-11 w-11 shrink-0 items-center justify-center rounded-[18px] border transition-all duration-200',
    active
      ? `${palette.iconActive} ${accent}`
      : `border-slate-200 bg-[linear-gradient(180deg,#f8fafc_0%,#f1f5f9_100%)] text-slate-500 ${palette.iconIdle} ${accent}`,
  ].join(' ');
};
